import { Routes } from "../routes";
import { getStoredUser } from "./access";

const TAB_KEY = "sgr_active_tab";
const TAB_ID = `t_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;

function apiBase() {
  return window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1"
    ? window.location.origin
    : "https://sgrloto.com";
}

function isExempt(user) {
  return !user || user.role === "SUPERADMIN" || user.role === "AGENT";
}

function clearAuth() {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("user_profile");
}

function claimLeadership() {
  localStorage.setItem(TAB_KEY, TAB_ID);
}

export function initSessionGuard({ onLeaderChange, onRevoked }) {
  const user = getStoredUser();
  if (isExempt(user)) {
    onLeaderChange(true);
    return () => {};
  }

  claimLeadership();
  onLeaderChange(true);

  const onStorage = (event) => {
    if (event.key !== TAB_KEY) return;
    onLeaderChange(event.newValue === TAB_ID);
  };
  window.addEventListener("storage", onStorage);

  let heartbeatTimer = null;
  const sendHeartbeat = async () => {
    const token = localStorage.getItem("access_token");
    if (!token) return;
    if (localStorage.getItem(TAB_KEY) !== TAB_ID) return;
    try {
      const res = await fetch(`${apiBase()}/api/session/heartbeat/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: "{}",
      });
      if (res.status === 401) {
        const body = await res.json().catch(() => ({}));
        if (body.code === "session_revoked" || String(body.detail || "").includes("simultanées")) {
          clearAuth();
          onRevoked();
        }
      }
    } catch (e) {
      // ignore réseau : ne pas déconnecter
    }
  };

  heartbeatTimer = window.setInterval(sendHeartbeat, 45000);
  sendHeartbeat();

  return () => {
    window.removeEventListener("storage", onStorage);
    if (heartbeatTimer) window.clearInterval(heartbeatTimer);
  };
}

export function takeTabControl() {
  claimLeadership();
}

export function isThisTabLeader() {
  const user = getStoredUser();
  if (isExempt(user)) return true;
  return localStorage.getItem(TAB_KEY) === TAB_ID;
}

export function redirectToSignin(history) {
  clearAuth();
  history.push(Routes.Signin.path);
}
